<template>
  <div v-if="store.getSelectedOffer?.size !== undefined">
    <div
      v-if="isShowSizeMap && store.getSelectedProduct.mkt?.sizes === undefined"
      class="mt-24"
    >
      <PopupTableSizes />
    </div>
    <div
      v-else-if="
        getSizePicture.length > 0 &&
        store.getSelectedProduct.mkt?.sizes === undefined
      "
      class="mt-24"
    >
      <PopupSizePicture />
    </div>
    <div v-else class="mt-24">
      <div class="grid-row d-flex_between">
        <div class="grid-col color-gray">Размер:</div>
        <div
          class="grid-col"
          v-if="store.getSelectedProduct.mkt?.sizes !== undefined"
        >
          <PopupCalculatorMkt />
        </div>
      </div>
    </div>
    <div class="grid-row grid-row_sm d-flex_wrap mt-8">
      <div class="grid-col pt-8" v-for="size in sizes" :key="size['id']">
        <ParamButton
          :name="availability ? 'size_availability' : 'size'"
          :value="size['id']"
          :checked="store.isActiveSize(size['id'])"
        >
          <template v-slot:param>
            {{ size["name"] }}
            <span
              v-if="getSizeInfo(size['xml_id'])"
              class="d-block fs-12 fw-light fs-sm-10 mt-2"
              >{{ getSizeInfo(size["xml_id"])["uf_type_size"] }}
              {{
                getSizeInfo(size["xml_id"])[
                  "uf_size_" +
                    getSizeInfo(size["xml_id"])["uf_type_size"].toLowerCase()
                ]
              }}</span
            >
          </template>
        </ParamButton>
      </div>
    </div>
  </div>
</template>

<script>
import PopupTableSizes from "@/pages/product_card/components/Popups/PopupTableSizes.vue";
import ParamButton from "@/pages/product_card/components/ParamButton/ParamButton.vue";
import { useProductStore } from "@/pages/product_card/stores/store_catalog";
import { pushToArray } from "@/pages/product_card/tools/functions";
import { mapState } from "pinia";
import PopupSizePicture from "@/pages/product_card/components/Popups/PopupSizePicture.vue";
import PopupCalculatorMkt from "@/pages/product_card/components/Popups/PopupCalculatorMkt.vue";

export default {
  name: "Sizes",
  components: {
    PopupCalculatorMkt,
    PopupSizePicture,
    PopupTableSizes,
    ParamButton,
  },
  props: {
    availability: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const store = useProductStore();

    return {
      store,
    };
  },
  mounted() {
    this.store.isSelected.size = this.sizes.length < 2;
  },
  computed: {
    ...mapState(useProductStore, [
      "getSizePicture",
      "isShowSizeMap",
      "getOffersForProduct",
    ]),
    sizes() {
      let data = [];
      const offers = this.getOffersForProduct;
      if (offers !== undefined && Object.keys(offers).length > 0) {
        Object.entries(offers).forEach((offer) => {
          const [, offerData] = offer;
          if (offerData?.reserve === false && this.availability) {
            return;
          }
          pushToArray(data, {
            id: offerData?.size?.id,
            name: offerData?.size?.name,
            xml_id: offerData?.size?.xml_id,
            reserve: offerData?.reserve,
          });
        });
      }

      return data;
    },
  },
  methods: {
    getSizeInfo(sizeGuid) {
      if (sizeGuid !== undefined) {
        let rows = this.store.getSelectedProduct.sizeMap?.rows;
        if (rows !== undefined && rows[sizeGuid] !== undefined) {
          return rows[sizeGuid];
        }
      }

      return false;
    },
  },
};
</script>

<style lang="scss">
@import "./sizes.scss";
</style>
